<!-- 节目集-节目管理页面 -->
<template>
  <div class="page-manager">
    <cs-form
      label-width="90px"
      form-width="100%"
      :form="form"
      :formData="searchData"
      :form-col="searchFormCol"
      :inline="true"
      class="header-search-box"
    >
      <template slot="updateTimeArr">
        <el-date-picker
          @change="formChange"
          v-model="updateTimeArr"
          type="datetimerange"
          value-format="yyyy-MM-dd HH:mm:ss"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期">
        </el-date-picker>
      </template>
      <template slot="search">
        <el-button type="primary" @click="search">查询</el-button>
        <el-button type="primary" @click="exportList">导出Excel</el-button>
      </template>
    </cs-form>
    <div class="padding-b-20">
      <el-button type="primary" @click="goGroupAdd()">批量加入</el-button>
      <el-button @click="handleSubmitDel()">批量移除</el-button>
    </div>
    <cs-table ref="tableProgram"
      :tableCols="tableCols"
      :tableData="tableData"
      :paginationOption="programPageOption"
      @size-change="sizeChangeHandler"
      @current-change="currentPageHandler"
      @selection-change="selectionChange">
      <template slot-scope="scope" slot="auditState"> {{scope.row.auditState|auditState}}</template>
      <template slot-scope="scope" slot="updateTime"> {{scope.row.updateTime|timeFormat}}</template>
      <template slot-scope="scope" slot="control">
        <el-tooltip class="item" effect="dark" content="移除" placement="top">
          <i @click="delEvent(scope.row)" class="icon-yichu-on icon-size"></i>
        </el-tooltip>
        <el-tooltip class="item" effect="dark" content="详情" placement="top">
          <i @click="goInsideDetailInfo(scope.row)" class="icon-xiangxi icon-size"></i>
        </el-tooltip>
      </template>
    </cs-table>
    <inside-dialog ref="insideDataDialog" :insideData="insideData" :goEdit="false" :groupIn="groupIn" :imgUrl="imgUrl"/>
    <batch-add-dialog ref="batchAddDialog"
    @refreshhMethod="refreshPage"
    :programSetId="programSetId" :category="dataParams.category"/>
    <!-- :form="'cp'" -->
  </div>
</template>
<script>
import { programs, bindOrUnbind } from '../../../resource/api/program-group-management'
import InsideDialog from '@/views/common/dialog/program-group-detail.vue'
import BatchAddDialog from '@/views/common/dialog/progroup-batch-add.vue'
export default {
  components: {
    InsideDialog,
    BatchAddDialog
  },
  data () {
    return {
      imgUrl: '',
      programSetId: '',
      dataParams: '',
      form: {
        name: '',
        startTime: '',
        endTime: '',
        operator: '',
        timeFlag: 'updateTime',
        programSetId: '',
        limit: 10,
        offset: 1
      },
      updateTimeArr: [],
      searchFormCol: { gutter: 10, sm: 12, md: 8, lg: 6 },
      tableCols: [
        { type: 'selection', width: 55 },
        { prop: 'name', label: '标题' },
        { prop: 'category', label: '一级分类' },
        { prop: 'sndCategory', label: '二级分类' },
        { prop: 'seriesNo', label: '集号' },
        { prop: 'auditState', label: '状态', type: 'slot' },
        { prop: 'updateTime', label: '更新时间', type: 'slot' },
        { prop: 'control', label: '操作', type: 'slot', width: 165 }
      ],
      tableData: [],
      programPageOption: {}, // 节目集发布分页参数
      programsMultipleSelect: [], // 节目集批量选中
      insideData: {},
      groupIn: 'program'
    }
  },
  computed: {
    searchData () {
      return [
        { prop: 'name', type: 'input', label: '标题：', placeholder: '请输入', clearable: false, labelWidth: '60px', col: [3, 3, 3] },
        {
          prop: 'operator',
          label: '操作人',
          type: 'input',
          placeholder: '请输入'
        },
        {
          prop: 'updateTimeArr',
          label: '更新时间：',
          type: 'slot'
        },
        { prop: 'search', type: 'slot', label: '', col: [3, 3, 3] }
      ]
    }
  },
  created () {
    this.pageInit()
  },
  methods: {
    refreshPage () {
      this.search()
    },
    // 初始化
    pageInit () {
      this.form.operator = this.$store.state.router.createBySuffix
      this.dataParams = JSON.parse(this.$route.query.dataParams)
      this.programSetId = this.dataParams.programSetId
      this.programPageOption['page-size'] = this.$store.state.pageLimit
      this.form.limit = this.$store.state.pageLimit
      this.form.programSetId = this.programSetId
      this.getData(this.form)
    },
    // 加载数据
    getData (data) {
      const that = this
      programs(data).then((res) => {
        if (res.code == 1 && res.results) {
          that.tableData = res.results
          this.programPageOption = {
            ...this.programPageOption,
            'current-page': this.form.offset,
            total: parseInt(res.total)
          }
        }
      })
    },
    formChange (timeArr) {
      if (timeArr === null) {
        this.form.startTime = ''
        this.form.endTime = ''
      } else {
        this.form.startTime = timeArr[0]
        this.form.endTime = timeArr[1]
      }
    },
    // 查询
    search (val) {
      this.form = {
        ...this.form,
        offset: 1,
        programSetId: this.programSetId
      }
      this.currentPageHandler(1)
    },
    // 导出
    exportList () {
      // window.location.href = process.env.VUE_APP_BASE_API_MGR + `/programs/exportList?name=${this.form.name}&startTime=${this.form.startTime}&endTime=${this.form.endTime}&timeFlag=${this.form.timeFlag}&operator=${this.form.operator}&programSetId=${this.form.programSetId}&limit=${this.form.limit}&offset=${this.form.offset}`
      const data = {
        name: this.form.name,
        startTime: this.form.startTime,
        endTime: this.form.endTime,
        timeFlag: this.form.timeFlag,
        programSetId: this.form.programSetId,
        operator: this.form.operator,
        limit: this.form.limit,
        offset: this.form.offset
      }
      this.$axios({
        // 跨域设置---------------------start
        async: true,
        crossDomain: true,
        withCredentials: true,
        headers: {
          AJAX: true
        },
        // 跨域设置---------------------end
        method: 'GET',
        url: process.env.VUE_APP_BASE_API_MGR + '/programs/exportList',
        params: data,
        responseType: 'blob',
        timeout: 1000 * 60 * 3
      }).then(res => {
        const blob = new Blob([res.data], { type: 'application/vnd.ms-excel' })

        const fileName = 'Excel_' + this.$moment(new Date()).format('YYYYMMDDHHmmss') +
          '.xls'
        const linkNode = document.createElement('a')

        linkNode.download = fileName // a标签的download属性规定下载文件的名称
        linkNode.style.display = 'none'
        linkNode.href = URL.createObjectURL(blob) // 生成一个Blob URL
        document.body.appendChild(linkNode)
        linkNode.click() // 模拟在按钮上的一次鼠标单击

        URL.revokeObjectURL(linkNode.href) // 释放URL 对象
        document.body.removeChild(linkNode)
      }).catch(err => {
        if (err.response && err.response.status == 601) {
          this.$message({
            type: 'error',
            message: '暂无数据可导出'
          })
        } else {
          this.$message({
            type: 'error',
            message: '程序异常'
          })
        }
      })
    },
    // 批量送审
    goGroupAdd () {
      this.$nextTick(() => {
        // 等待dom同步后打开模态框
        this.$refs.batchAddDialog.open()
      })
    },
    // 批量删除
    handleSubmitDel () {
      if (this.multipleSelection.length == 0) {
        this.$message('还没有选中内容')
        return
      }
      this.$confirm('确定永久移除吗?', '移除提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const data = {
          bindOrUnbindFlag: '批量解绑',
          programIds: this.multipleSelection,
          updateBy: this.$store.state.router.updateBySuffix
        }
        bindOrUnbind(data).then((res) => {
          if (res.code == 1) {
            this.$message({
              message: '批量移除成功',
              type: 'success'
            })
            this.currentPageHandler(1)
          } else {
            this.$message.error(res.msg)
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消移除'
        })
      })
    },
    // 移除单个节目
    delEvent (row) {
      const that = this
      that.$confirm('确定永久移除吗?', '移除提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const data = {
          programIds: [row.id],
          updateBy: this.$store.state.router.updateBySuffix
        }
        bindOrUnbind(data).then((res) => {
          if (res.code == 1) {
            that.$message({
              message: '移除成功',
              type: 'success'
            })
            that.currentPageHandler(1)
          } else {
            that.$message.error(res.msg)
          }
        })
      }).catch(() => {
        that.$message({
          type: 'info',
          message: '已取消移除'
        })
      })
    },
    // 获取选中数据
    selectionChange (selection) {
      this.multipleSelection = selection.map(item => item.id)
    },
    sizeChangeHandler (val) {
      this.form.limit = val
      this.form.offset = 1
      this.getData(this.form)
    },
    currentPageHandler (val) {
      this.form.offset = val
      this.getData(this.form)
    },
    // 查看详情
    goInsideDetailInfo (row) {
      this.insideData = row
      this.imgUrl = this.insideData.video.videoImgPaths[0].imgPath
      this.$nextTick(() => {
        // 等待dom同步后打开模态框
        this.$refs.insideDataDialog.open()
      })
    }
  }
}
</script>
<style scoped>
  .padding-b-20{
    padding-bottom: 20px;
  }
</style>
